import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';

@Component({
  selector: 'common-bottom-sheet-header',
  templateUrl: './bottom-sheet-header.component.html',
  styleUrls: ['./bottom-sheet-header.component.scss']
})
export class BottomSheetHeaderComponent implements OnInit {

  @Input() title = '';
  @Input() hideCloseButton = false;

  constructor(private modalService: ModalService) { }

  ngOnInit(): void {
  }

  close(): void {
    this.modalService.dismiss();
  }
}
